/**
 * Framer Motion presets — scroll reveals, stagger, reduced-motion safe usage.
 */

export const viewportDefault = {
  once: true,
  amount: 0.12,
  margin: "0px 0px -10% 0px",
};

export const viewportTight = {
  once: true,
  amount: 0.2,
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0.08,
      when: "beforeChildren",
    },
  },
};

export const staggerFast = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.05,
      when: "beforeChildren",
    },
  },
};

/** Enterprise-style ease-out */
export const fadeUp = {
  hidden: { opacity: 0, y: 22 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.52, ease: [0.22, 1, 0.36, 1] },
  },
};

export const fadeUpReduced = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.97 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.48, ease: [0.22, 1, 0.36, 1] },
  },
};

export function pickFade(reduceMotion) {
  return reduceMotion ? fadeUpReduced : fadeUp;
}

export function pickStagger(reduceMotion) {
  if (reduceMotion) {
    return {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: { staggerChildren: 0.04, delayChildren: 0.04 },
      },
    };
  }
  return staggerContainer;
}
